export const AUDIO_MESSAGE_RECORD_MODAL_NAME = 'audioMessageRecord';

export const AUDIO_EXAMPLE_SRC = 'https://dev.youhelp.ru/assets/4d3d9c5c.mp3';
